<template>
  <div :style="style" class="base-hero-scroll">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseHeroScroll',
  props: {
    imageURL: {
      type: String,
      required: true
    },
    opacity: {
      type: Number,
      default: 0.4
    }
  },
  computed: {
    style () {
      return 'background-image: linear-gradient(rgba(0, 0, 0, ' + this.opacity + '), rgba(0, 0, 0, ' + this.opacity + ')), url(' + this.imageURL + ')'
    }
  }
}
</script>

<style scoped lang="scss">

      .base-hero-scroll {
        background-size: cover;
        background-position: center;
        background-attachment: fixed;
        height: 60vh;
      }

      @media screen and (orientation: landscape) and (max-height: 575.98px) {
        .base-hero-scroll {
          height:100vh;
        }
      }

</style>
